import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, DownloadIcon } from 'lucide-react';
export function MainCTA() {
  const scrollToBuyNow = () => {
    const target = document.getElementById('comprar-ahora');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="main-cta" className="py-16 md:py-24 px-4 bg-gradient-to-br from-accent-blush to-accent-lilac" data-id="element-173">
      <div className="max-w-4xl mx-auto text-center" data-id="element-174">
        <motion.h2 className="font-heading text-3xl md:text-5xl font-bold text-heading mb-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-175">
          ¿Sigues leyendo? Eso significa que esto te importa.
        </motion.h2>

        <motion.p className="text-lg md:text-xl text-body mb-10 leading-relaxed max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-176">
          No más búsquedas interminables en Google. No más dudas sin resolver.
          No más ciclos de automedicación sin entender qué está pasando. La
          información que necesitas está aquí. Clara, organizada y lista para
          ti.
        </motion.p>

        <motion.button onClick={scrollToBuyNow} className="bg-button text-white px-12 py-6 rounded-full text-xl md:text-2xl font-bold hover:bg-[#A88BA8] transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 mb-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} data-id="element-177">
          📥 Quiero mi guía ahora
        </motion.button>

        <motion.div className="flex flex-col md:flex-row items-center justify-center gap-6 text-body" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-178">
          <div className="flex items-center gap-2" data-id="element-179">
            <LockIcon className="w-5 h-5" data-id="element-180" />
            <span data-id="element-181">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-182">
            <ZapIcon className="w-5 h-5" data-id="element-183" />
            <span data-id="element-184">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-185">
            <DownloadIcon className="w-5 h-5" data-id="element-186" />
            <span data-id="element-187">Descarga instantánea</span>
          </div>
        </motion.div>
      </div>
    </section>;
}